import {createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import {zadImportUrl} from '../../api'
import {sanitizeZadImportPayload} from '../zad/importParse'
import {parseZadApiError} from '../zad/errors'
import {ImportZadCatalogRequest} from './types'

export const importZadCatalog = createAsyncThunk(
  'zadImport/import',
  async (payload: ImportZadCatalogRequest, {rejectWithValue}) => {
    try {
      const body = sanitizeZadImportPayload(payload)
      const res = await axios.post(zadImportUrl, body)
      return {
        success: true as const,
        imported: res.data.imported,
        categories: Array.isArray(res.data.categories) ? res.data.categories : [],
        productTypes: Array.isArray(res.data.productTypes) ? res.data.productTypes : [],
        usedTransaction: res.data.usedTransaction,
      }
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)
